import "./style.css";
import { useTranslation } from "../../i18n/LanguageContext";

const VolunteerAgreement = () => {
    const { t } = useTranslation();
    return (
        <div className="main-content-wrapper">
            <div className="VolunteerAgreementPage">
                <h2>{t("legal.agreement")}</h2>
                <p>{t("legal.updated")}</p>
                <p>{t("agreement.intro")}</p>
                {t("agreement.sections").map((s, i) => (
                    <div key={i}>
                        <h4>{s.h}</h4>
                        <p>{s.t}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default VolunteerAgreement;
